import docReady from './Functions/docReady'
import { buildVisiblePrice } from './Functions/buildVisiblePrice.js'
import tippy, { followCursor } from 'tippy.js';

import MapNew from './Functions/initMap';

docReady(function () {

    document.body.classList.add('page-prices');
    let map;
    var app1 = new Vue({
        el: '.pic-under-navbar',
        data: {
            search: '',
            windowWidth: window.innerWidth,
            lastSelected: '',
            sortBy: 'name',
            sortDirection: 'asc',
            language: window.currentLanguageCode,
            isMediaXs: false,
            showMapModal: false,
        },
        computed: {
            filteredList: function () {
                return model.partners.filter(item => {
                    return item.name.toLowerCase().includes(this.search.toLowerCase())
                })
            },
            sortedProducts: function () {
                return this.filteredList.sort((p1, p2) => {
                    let modifier = 1;
                    if (this.sortDirection === 'desc') modifier = -1;
                    if (p1[this.sortBy] < p2[this.sortBy]) return -1 * modifier; if (p1[this.sortBy] > p2[this.sortBy]) return 1 * modifier;
                    return 0;
                });
            }
        },
        mounted: function () {
            var mqXs = window.matchMedia('(max-width: 767px)');
            this.isMediaXs = mqXs.matches;

            window.onresize = () => {
                this.windowWidth = window.innerWidth
            }
        },
        methods: {
            toggleMap: function (selectedPrintPointName) {
                this.showMapModal = !this.showMapModal;

                if (!map) {
                    map = new MapNew(selectedPrintPointName);
                } else {
                    map.changePrintPoint(selectedPrintPointName);
                }
            },
            selectItem: function (priceItem) {
                this.lastSelected = priceItem;
            },
            sort: function (s) {
                if (s === this.sortBy) {
                    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
                }
                this.sortBy = s;
            }
        }
    });
    if (!app1.isMediaXs) {
        tippy('[data-tippy-content]', {
            followCursor: 'horizontal',
            plugins: [followCursor],
        });
    }
});

Vue.component('partner-prices-mobile', {
    template: '#partner-prices-mobile-template',
    props: ['priceItem'],
    methods: {
        backToAllPrices: function () {
            if (window.matchMedia('(max-width: 768px)').matches) {
                var price = document.getElementsByClassName('pic-under-navbar')[0]
                price.scrollTop = 0;
                window.scrollTo(0, 0);
                document.getElementById('prices-header').classList.remove('active');
                document.getElementById('partners').classList.add('active');
            }
        },
    }
});

Vue.component('partner-row-mobile', {
    template: '#partner-row-mobile-template',
    props: ['priceItem'],
    methods: {
        getPrice: function (pagePrice) {
            return (isNaN(parseInt(pagePrice)) || pagePrice <= 0) ? '-' : buildVisiblePrice(pagePrice, model.currencyInfo, 2, 4);
        },
    }
});

Vue.component('partner-row', {
    template: '#partner-row-template',
    data: function () {
        return {
            isSelected: false,
        }
    },
    props: ['priceItem'],
    emits: ['toggle-map', 'select-partner'],
    methods: {
        getPrice: function (pagePrice) {
            return (isNaN(parseInt(pagePrice)) || pagePrice <= 0) ? '-' : buildVisiblePrice(pagePrice, model.currencyInfo, 2, 4);
        },
        toggleMap: function (name) {
            if (window.matchMedia('(max-width: 768px)').matches) {
                this.selectPartner();
                this.$emit('select-partner');
            } else {
                this.$emit('toggle-map', name);
            }
        },
        selectPartner: function (discountCount) {

            if (window.matchMedia('(max-width: 768px)').matches) {
                document.getElementById('prices-header').classList.add('active');
                document.getElementById('partners').classList.remove('active');
            } else {
                if (discountCount) {
                    this.isSelected = !this.isSelected;
                }
            }
        },
    }
});

Vue.component('file-settings-icon', {
    template: '#file-settings-icons-template',
    props: ['iconGroup', 'iconInGroup', 'duplexMode'],
    mounted: function () {
        //$('[data-toggle="tooltip"]').tooltip();
    }
});